import { Outlet } from "react-router";
import { Footer, HeaderTop } from "@motain/web-shared-hub/ui/blocks";
import { OFTVLogo } from "@features/pageLayout/constants/OFTVlogo";
import { toggleDarkTheme } from "@motain/web-shared-hub/services";
import { HEADER_TRANSLATED_TEXT } from "@features/pageLayout/constants/headerTranslatedText";
import { FooterConfig } from "@features/pageLayout/constants/footerConfig";
import { selectIsDarkTheme } from "@motain/web-shared-hub/services";
import { useAppDispatch, useAppSelector } from "@/shared/hooks/appHooks";
import { useLocale } from "@/shared/hooks/useLocale";
import { PageLayoutContainerOutletWrapper } from "@features/pageLayout/elements/PageLayoutContainerOutletWrapper";
import { useRedirectUrl } from "@/shared/hooks/useRedirectUrl";
import { useSetLocaleFromURL } from "@/shared/hooks/useSetLocaleFromURL";

export const PageLayoutContainer = () => {
  const dispatch = useAppDispatch();
  const { t, locale } = useLocale();
  const isDarkMode = useAppSelector(selectIsDarkTheme);
  const redirectUrl = useRedirectUrl();
  useSetLocaleFromURL();

  const handleThemeChange = () => {
    dispatch(toggleDarkTheme(!isDarkMode));
    localStorage.setItem("isDarkTheme", JSON.stringify(!isDarkMode));
  };

  return (
    <>
      <HeaderTop
        isClientSide={false}
        DefaultLogoLink={""}
        logoLink={redirectUrl}
        imageHeader={OFTVLogo}
        onSendTrackingEvent={() => {}}
        onChangeTheme={handleThemeChange}
        translatedText={HEADER_TRANSLATED_TEXT(t)}
        isDarkMode={isDarkMode}
        locale={locale}
      ></HeaderTop>
      <PageLayoutContainerOutletWrapper>
        <Outlet />
      </PageLayoutContainerOutletWrapper>
      <Footer {...FooterConfig(isDarkMode, t)}></Footer>
    </>
  );
};
